import { render, staticRenderFns } from "./pickUp_details.vue?vue&type=template&id=4de294c8&scoped=true&"
import script from "./pickUp_details.vue?vue&type=script&lang=js&"
export * from "./pickUp_details.vue?vue&type=script&lang=js&"
import style0 from "./pickUp_details.vue?vue&type=style&index=0&id=4de294c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de294c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de294c8')) {
      api.createRecord('4de294c8', component.options)
    } else {
      api.reload('4de294c8', component.options)
    }
    module.hot.accept("./pickUp_details.vue?vue&type=template&id=4de294c8&scoped=true&", function () {
      api.rerender('4de294c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pickUp/pickUp_details.vue"
export default component.exports